import { useState } from "react";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { download, errMsg, todayIST } from "@/lib/api";
import { PageHeader, Field } from "@/components/common";

const shift = (d, n) => { const x = new Date(`${d}T00:00:00`); x.setDate(x.getDate() + n); return x.toLocaleDateString("en-CA"); };
const T = todayIST();
const Y = shift(T, -1);
const M1 = `${T.slice(0, 7)}-01`;
const FIXED = [
  ["Today's Cutting Register", "cutting", T, T], ["Today's Stock Inward", "inward", T, T], ["Today's Dispatch Register", "dispatch", T, T],
  ["Today's Complete Inventory Report (9 sheets)", "complete", T, T], ["Yesterday's Complete Report", "complete", Y, Y], ["Monthly Inventory Report (this month)", "complete", M1, T],
];
const CUSTOM = [["Brand-Wise Stock", "brand"], ["Cable Size-Wise Stock", "size"], ["Drum-Wise Stock", "drum"], ["Party-Wise Dispatch", "party"],
  ["Employee-Wise Cutting", "employee"], ["Complete Inventory Ledger", "ledger"], ["Cutting Register", "cutting"], ["Stock Inward", "inward"],
  ["Dispatch Register", "dispatch"], ["Complete Inventory Report", "complete"], ["Pending Dispatches", "pending"]];

export default function Reports() {
  const [from, setFrom] = useState(M1);
  const [to, setTo] = useState(T);
  const [busy, setBusy] = useState("");
  const get = async (kind, d1, d2, key) => {
    setBusy(key);
    try { await download(`/reports/${kind}.xlsx?date_from=${d1}&date_to=${d2}`, kind === "complete" && d1 === d2 ? `Roxy_Cables_Daily_Inventory_${d1}.xlsx` : `Roxy_${kind}_${d1}_to_${d2}.xlsx`); } catch (e) { toast.error(errMsg(e)); }
    setBusy("");
  };
  return (
    <div className="space-y-6">
      <PageHeader title="Download Reports" subtitle="Excel reports from posted transactions. Stock sheets show balances as of the end date. For PDF, use Print on the register and ledger pages." />
      <section>
        <div className="text-[11px] uppercase tracking-wider font-semibold text-muted-foreground mb-2">Quick downloads</div>
        <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-3">
          {FIXED.map(([label, kind, d1, d2], i) => (
            <button key={label} onClick={() => get(kind, d1, d2, `f${i}`)} disabled={!!busy} data-testid={`report-quick-${i}`}
              className="rounded-lg border bg-card p-4 text-left hover:border-primary/50 transition-colors flex items-center gap-3">
              <Download className="h-5 w-5 text-red-600 shrink-0" /><div><div className="font-medium text-sm">{label}</div><div className="text-xs text-muted-foreground font-mono">{d1 === d2 ? d1 : `${d1} → ${d2}`}{busy === `f${i}` ? " · preparing…" : ""}</div></div>
            </button>
          ))}
        </div>
      </section>
      <section className="rounded-lg border bg-card p-4 space-y-3">
        <div className="text-[11px] uppercase tracking-wider font-semibold text-muted-foreground">Custom date range</div>
        <div className="flex flex-wrap gap-3">
          <Field label="From"><Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} data-testid="report-from-input" /></Field>
          <Field label="To"><Input type="date" value={to} max={T} onChange={(e) => setTo(e.target.value)} data-testid="report-to-input" /></Field>
        </div>
        <div className="flex flex-wrap gap-2">
          {CUSTOM.map(([label, kind]) => <Button key={kind} variant="outline" disabled={!!busy} onClick={() => get(kind, from, to, kind)} data-testid={`report-custom-${kind}`}><Download className="h-4 w-4 mr-1" />{busy === kind ? "Preparing…" : label}</Button>)}
        </div>
      </section>
    </div>
  );
}
